import React,{ useEffect, useRef, useState,}from 'react'
import { Form,App, Input, Modal} from 'antd';
import { useBnsBanBenAddMutation } from '../../store/BnsKeJiApi';
import { PlusSquareOutlined } from '@ant-design/icons';
const {TextArea} = Input
function SubmoduleAdd(props) {    
    const {message} = App.useApp();
    const [form] = Form.useForm();
    const [add]  = useBnsBanBenAddMutation()
    const [info,setInfo] = useState({
        bbb_xuzhi:'',
        bbb_jihua:'',
        bbb_bg_id:props.bg_id,
        bbb_bg_name:props.bg_name,
        bbb_dept_id:'540',
        bbb_dept_name:'开发部',
        bbb_bgn_id:props.bgn_id,
        bbb_bgn_name:props.bgn_name,
    });
    const [open, setOpen] = useState(false);
    const editForm = useRef();
    useEffect(() => {
        setInfo(prevState => ({
            ...prevState,
            bbb_bg_id:props.bg_id,
            bbb_bg_name:props.bg_name,
            bbb_dept_id:props.bg_dept_id,
            bbb_dept_name:props.bg_dept_name,
            bbb_bgn_id:props.bgn_id,
            bbb_bgn_name:props.bgn_name,
        }));
        
        if (editForm.current) {
            editForm.current.setFieldsValue({
                bgn_bg_id: props.bg_id,
                bbb_bgn_id:props.bgn_id
            });
        }
    }, [props.bg_id, props.bg_dept_id, props.bg_dept_name,props.bg_name,props.bgn_id,props.bgn_name,open]);
    return (
            <>
                <a onClick={() => {setOpen(true)}} style={{width:"100px"}}><PlusSquareOutlined /> 新增子模块</a>
                <Modal
                    open={open}
                    width={800}
                    title={props.bg_name + ' - ' + props.bgn_name + '- 新增子模块'}
                    onCancel={() => {setOpen(false)}}
                    onOk={() => {
                        form.resetFields();  
                        add({
                            "bbb_bg_id" : info.bbb_bg_id,
                            "bbb_bg_name" : info.bbb_bg_name,
                            "bbb_cid" :  localStorage.getItem('eu_id'),
                            "bbb_cname" : localStorage.getItem('eu_name'),
                            "bbb_dept_id" : info.bbb_dept_id,
                            "bbb_dept_name" : info.bbb_dept_name,
                            "bbb_e_id" : localStorage.getItem('e_id'),
                            "bbb_jihua" : info.bbb_jihua,
                            "bbb_name" : info.bbb_name,
                            "bbb_xuzhi" : info.bbb_xuzhi,                                    
                            "bbb_bgn_id" : info.bbb_bgn_id,                                    
                            "bbb_bgn_name" : info.bbb_bgn_name,                                    
                        }).then((res) => {
                            if (res.data.Status === 'success') {
                                message.info('新增成功！');
                                setOpen(false)   
                            }
                            if (res.data.Status === "fail") {
                                message.error('新增失败！'+res.data.Message)
                            }
                        })       
                    }}
                >
                    <Form
                        form={form}
                        layout="horizonal"
                        name="form_client_add"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 3 }}
                        wrapperCol={{ span: 11 }}
                        ref={editForm}
                    >
                        <Form.Item 
                            name="title" 
                            label='子模块名称' 
                            wrapperCol={{span:10}} 
                            required
                        >
                            <Input
                                onChange={(e) => {setInfo(prevState=>({...prevState,bbb_name:e.target.value}))}}
                            />
                        </Form.Item> 
                        <Form.Item 
                            name="name" 
                            label='子模块说明' 
                            wrapperCol={{span:20}}                         
                        >
                            <TextArea 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bbb_xuzhi:e.target.value}))}}
                            />
                        </Form.Item>                                               
                    </Form>
                </Modal>
            </>
        )
}

export default SubmoduleAdd